import {
  Component,
  Inject,
  OnInit,
  Optional,
  Renderer2,
  ChangeDetectionStrategy
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { UtilsService } from 'src/app/shared/utils.service';
import { ToolboxTalksTemplatesEditComponent } from '../toolbox-talks-templates-edit/toolbox-talks-templates-edit.component';
import { FileService } from 'src/app/shared/file.service';
import { ApiRequestService } from 'src/app/shared/api-request.service';
import { RBACService } from '../../shared/rbac.service';

@Component({
  selector: 'app-toolbox-talks-templates-edit-dialog',
  templateUrl: './toolbox-talks-templates-edit-dialog.component.html',
  styleUrls: ['./toolbox-talks-templates-edit-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ToolboxTalksTemplatesEditDialogComponent
  extends ToolboxTalksTemplatesEditComponent
  implements OnInit {
  constructor(
    public app: AppService,
    api: ApiRequestService,
    public router: Router,
    public renderer: Renderer2,
    public utils: UtilsService,
    @Optional()
    public dialogRef: MatDialogRef<ToolboxTalksTemplatesEditDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any,
    fileService: FileService,
    rbac: RBACService
  ) {
    super(
      app,
      api,
      router,
      renderer,
      utils,
      fileService,
      rbac,
      dialogData['id'],
      dialogRef
    );

    this.toolbox_talk_template.id = Number(this.dialogData['id']);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  async onSubmit(form: NgForm) {
    super.onSubmit(form);
  }

  onClose() {
    this.dialogRef.close();
  }
}
